// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  width: 100%;
  height: 70px;
}
.header .header-main-top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.header .header-main-top .language-icon {
  height: 18px;
  width: 18px;
}
.header .header-main-top .second-header {
  display: flex !important;
}
.header .header-main-top .second-header .icon-button {
  color: inherit !important;
  margin-right: 10px;
}
.header .header-main-top .language-notificatios {
  display: flex;
  align-items: center;
}
.header .header-main-top .language-notificatios .right-header {
  align-items: center;
}
.header .header-main-top .language-notificatios .right-header .user-title {
  margin-left: 4px;
}
.header .header-main-top .language-notificatios .right-header .notification-menu {
  position: relative;
  display: flex;
}
.header .header-main-top .language-notificatios .right-header .render-language {
  display: flex;
  align-items: center;
  margin-right: 4px;
}
.header .header-main-top .language-notificatios .right-header .render-language .title {
  margin-left: 6px;
}
.header .header-main-top .eng-uk {
  white-space: nowrap;
}
.header .header-main-top .header-search {
  position: relative;
  display: flex;
  align-items: center;
}
.header .header-main-top .header-search .common-cards-width-closed {
  width: 270px !important;
}
.header .header-main-top .header-search .search-icon {
  position: absolute;
  right: 15px;
}
.header .header-main-top .header-search .collapsed-search-input {
  border-radius: 18px !important;
  padding: 8px 40px 8px 21px;
}
.header .header-main-top .header-search .open-search-input {
  border-radius: 4px !important;
  padding: 8px 40px 8px 21px !important;
}
.header .header-main-top .header-search .input-search {
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(131, 164, 249, 0.15);
  height: 34px;
}
.header .header-main-top .header-search .input-search:focus {
  outline: #ff611d;
  border: 1px solid #ff611d;
}
.header .header-main-top .profile-img {
  border-radius: 50% !important;
  padding: 0.25rem !important;
  border-width: 2px !important;
  border: 1px solid #dee2e6 !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  height: 35px;
  width: 35px;
  margin-top: 4px;
}

@media screen and (min-width: 690px) {
  .header .header-main-top .common-cards-width-open {
    width: 270px !important;
  }
}
@media screen and (min-width: 652px) and (max-width: 689px) {
  .header .header-main-top .common-cards-width-open {
    width: 240px !important;
  }
}
@media screen and (min-width: 621px) and (max-width: 651px) {
  .header .header-main-top .common-cards-width-open {
    width: 220px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 620px) {
  .header .header-main-top .common-cards-width-open {
    width: 200px !important;
  }
}
@media screen and (max-width: 400px) {
  .header .header-main-top .common-cards-width-open {
    width: 200px !important;
  }
}
@media screen and (min-width: 397px) and (max-width: 599px) {
  .header .header-main-top .header-search .input-search {
    width: 270px !important;
  }
}
@media screen and (max-width: 396px) {
  .header .header-main-top .header-search .input-search {
    width: 200px !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .header .header-main-top .second-header {
    width: 100%;
  }
}
@media screen and (max-width: 314px) {
  .header .header-main-top .header-parent .search-icon {
    display: none;
  }
}
@media screen and (max-width: 600px) {
  .header .header-main-top .header-parent .search-icon {
    top: 20px !important;
  }
}
@media screen and (max-width: 400px) {
  .header .header-main-top .header-parent .collapsed-search-input {
    padding: 8px 0px 8px 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/header/header.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACI;EACE,YAAA;EACA,WAAA;AACN;AAEI;EACE,wBAAA;AAAN;AAEM;EACE,yBAAA;EACA,kBAAA;AAAR;AAII;EAEE,aAAA;EACA,mBAAA;AAHN;AAKM;EACE,mBAAA;AAHR;AAKQ;EACE,gBAAA;AAHV;AAMQ;EACE,kBAAA;EACA,aAAA;AAJV;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AALV;AAOU;EACE,gBAAA;AALZ;AAWI;EACE,mBAAA;AATN;AAYI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAVN;AAaM;EACE,uBAAA;AAXR;AAcM;EACE,kBAAA;EACA,WAAA;AAZR;AAeM;EACE,8BAAA;EACA,0BAAA;AAbR;AAgBM;EACE,6BAAA;EACA,qCAAA;AAdR;AAiBM;EACE,WAAA;EACA,mBChFM;EDiFN,2CAAA;EACA,YAAA;AAfR;AAiBQ;EACE,gBCzFM;ED0FN,yBAAA;AAfV;AAoBI;EACE,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,wDAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAlBN;;AA6BM;EADF;IAEI,uBAAA;EAzBN;AACF;AA2BM;EALF;IAMI,uBAAA;EAxBN;AACF;AA0BM;EATF;IAUI,uBAAA;EAvBN;AACF;AAyBM;EAbF;IAcI,uBAAA;EAtBN;AACF;AAwBM;EAjBF;IAkBI,uBAAA;EArBN;AACF;AA2BQ;EADF;IAEI,uBAAA;EAxBR;AACF;AA0BQ;EALF;IAMI,uBAAA;EAvBR;AACF;AA4BM;EADF;IAEI,WAAA;EAzBN;AACF;AA8BQ;EADF;IAEI,aAAA;EA3BR;AACF;AA6BQ;EALF;IAMI,oBAAA;EA1BR;AACF;AA8BQ;EADF;IAEI,oCAAA;EA3BR;AACF","sourcesContent":["@import \"../../styles/variables\";\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 10px;\n  width: 100%;\n  height: 70px;\n\n  .header-main-top {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n\n    .language-icon {\n      height: 18px;\n      width: 18px;\n    }\n\n    .second-header {\n      display: flex !important;\n\n      .icon-button {\n        color: inherit !important;\n        margin-right: 10px;\n      }\n    }\n\n    .language-notificatios {\n\n      display: flex;\n      align-items: center;\n\n      .right-header {\n        align-items: center;\n\n        .user-title {\n          margin-left: 4px;\n        }\n\n        .notification-menu {\n          position: relative;\n          display: flex\n        }\n\n        .render-language {\n          display: flex;\n          align-items: center;\n          margin-right: 4px;\n\n          .title {\n            margin-left: 6px;\n          }\n        }\n      }\n    }\n\n    .eng-uk {\n      white-space: nowrap;\n    }\n\n    .header-search {\n      position: relative;\n      display: flex;\n      align-items: center;\n\n\n      .common-cards-width-closed {\n        width: 270px !important;\n      }\n\n      .search-icon {\n        position: absolute;\n        right: 15px;\n      }\n\n      .collapsed-search-input {\n        border-radius: 18px !important;\n        padding: 8px 40px 8px 21px;\n      }\n\n      .open-search-input {\n        border-radius: 4px !important;\n        padding: 8px 40px 8px 21px !important;\n      }\n\n      .input-search {\n        width: 100%;\n        background: $white-color;\n        border: 1px solid rgba(131, 164, 249, 0.15);\n        height: 34px;\n\n        &:focus {\n          outline: $primary-color;\n          border: 1px solid $primary-color;\n        }\n      }\n    }\n\n    .profile-img {\n      border-radius: 50% !important;\n      padding: 0.25rem !important;\n      border-width: 2px !important;\n      border: 1px solid #dee2e6 !important;\n      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n      height: 35px;\n      width: 35px;\n      margin-top: 4px;\n    }\n  }\n}\n\n\n\n// Media Queries\n.header {\n  .header-main-top {\n    .common-cards-width-open {\n      @media screen and (min-width: 690px) {\n        width: 270px !important\n      }\n\n      @media screen and (min-width: 652px) and (max-width: 689px) {\n        width: 240px !important\n      }\n\n      @media screen and (min-width: 621px) and (max-width: 651px) {\n        width: 220px !important\n      }\n\n      @media screen and (min-width: 600px) and (max-width: 620px) {\n        width: 200px !important\n      }\n\n      @media screen and (max-width: 400px) {\n        width: 200px !important\n      }\n    }\n\n    .header-search {\n\n      .input-search {\n        @media screen and (min-width: 397px) and (max-width: 599px) {\n          width: 270px !important\n        }\n\n        @media screen and (max-width: 396px) {\n          width: 200px !important\n        }\n      }\n    }\n\n    .second-header {\n      @media screen and (min-width: 400px) and (max-width: 600px) {\n        width: 100%;\n      }\n    }\n\n    .header-parent {\n      .search-icon {\n        @media screen and (max-width: 314px) {\n          display: none;\n        }\n\n        @media screen and (max-width: 600px) {\n          top: 20px !important;\n        }\n      }\n\n      .collapsed-search-input {\n        @media screen and (max-width: 400px) {\n          padding: 8px 0px 8px 12px !important;\n        }\n      }\n    }\n  }\n}","// all color, text-sizes, border-radius etc  should be initialize here as variables and use them in styling\n// do not write explicitly values.\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n//colors\n$primary-color: #ff611d;\n$secondary-color: #333333;\n\n$black-color: #000000;\n$white-color: #ffffff;\n$dark-gray-color: #3c3c3c;\n$grey-color: #747070;\n$orange-color: #ff8908;\n$yellow-color: #ffb80e;\n$link-color: #59a9ff;\n$orange-yellowish-color: #ffa412;\n$mid-green-color: #00d27a;\n$apple-green-color:#659c35;\n$dark-white-smoke-color: #f5f8fe;\n$mix-grey-color: linear-gradient(180deg, #464c52 0%, #464c5299 100%);\n$orange-color-300: #FFA300;\n\n$solitude-color:#E9EFFD;\n$error-color: #dc3545;\n$alert-text-color:#81222C;\n$success-color: #165c27;\n$alertgreen-color: #d0e7d6;\n$alertred-color:#F7D5D8;\n$selected-tap-color: #1c1b1b;\n$rate-star-color: #ffce31;\n$icon-color: #c4c4c4;\n$selected-field-color: #6c757d;\n$hover-color: #fee6dd;\n$blue_magenta_color: #EBEBEE;\n$green-color:#40d698;\n$light-gray-color:#9d99b9;\n$mid-gray: #676c70;\n\n//font-size\n$primary-heading: 32px;\n$secondary-heading: 24px;\n$tertiary-heading: 28px;\n$heading-48: 48px;\n$heading-42: 42px;\n$heading-20: 20px;\n$heading-22: 22px;\n$heading-18: 18px;\n\n$primary-title: 16px;\n$secondary-title: 14px;\n$tertiary-title: 12px;\n$title-15: 15px;\n$title-13: 13px;\n$title-10: 10px;\n\n//border-radius\n$border-radius-4: 4px;\n$border-radius-5: 5px;\n$border-radius-10: 10px;\n$border-radius-15: 15px;\n$border-radius-20: 20px;\n$border-radius-rounded:50%;\n\n//font-weight\n$font-weight-300: 300;\n$font-weight-400: 400;\n$font-weight-500: 500;\n$font-weight-600: 600;\n$font-weight-700: 700;\n$font-weight-800: 800;\n$font-weight-900: 900;\n\n//font-family\n$font-family-montserrat: \"Montserrat\", \"Roboto\", \"sans-serif\";\n$font-family-roboto: \"Roboto\", \"sans-serif\", \"Montserrat\";"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
